// extracted by mini-css-extract-plugin
module.exports = {"author":"PostAuthor--author--181km","profileImage":"PostAuthor--profileImage--1Bu3l","authorText":"PostAuthor--authorText--3as4v"};